import React from 'react'
import { styled, utilities } from '@creditas/stylitas'
import { func } from 'prop-types'

import { Action } from '@creditas/icons'

const Wrapper = styled.div`
  align-self: center;
`

const Button = styled.button`
  ${utilities.reset.button()}
  cursor: pointer;
  height: 48px;
  width: 48px;

  &:focus {
    outline: none;
  }
`

const CloseButton = ({ closeToast }) => (
  <Wrapper>
    <Button data-testid="notification-times" onClick={closeToast}>
      <Action.IconSystemClose fontSize="large" color="#aabbbb" />
    </Button>
  </Wrapper>
)

CloseButton.propTypes = {
  closeToast: func,
}

export { CloseButton }
